import { useMemo } from 'react'

import { ArticleList, IArticleListItem } from 'src/components/molecules'

import { IPortfolioNewsArticleEntity } from '../types'

interface IPortfolioNewsMobileListProps {
  articles: IPortfolioNewsArticleEntity[]
  onArticleClick?: (article: IPortfolioNewsArticleEntity) => void
}

const formatMeta = (article: IPortfolioNewsArticleEntity): string =>
  `${article.company} · ${article.source} · ${article.publishedDisplay}`

export const PortfolioNewsMobileList = ({
  articles,
  onArticleClick,
}: IPortfolioNewsMobileListProps): JSX.Element => {
  const items: IArticleListItem[] = articles.map(
    (article): IArticleListItem => ({
      id: article.id,
      title: article.articleName,
      meta: formatMeta(article),
    }),
  )

  const articlesById = useMemo(
    (): Map<string, IPortfolioNewsArticleEntity> =>
      new Map(
        articles.map((article): [string, IPortfolioNewsArticleEntity] => [
          article.id,
          article,
        ]),
      ),
    [articles],
  )

  const handleItemClick = onArticleClick
    ? (item: IArticleListItem): void => {
        const article = articlesById.get(item.id)
        if (article) {
          onArticleClick(article)
        }
      }
    : undefined

  return (
    <ArticleList
      items={items}
      ariaLabel="Portfolio news"
      onItemClick={handleItemClick}
    />
  )
}
